import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./TaskCard.module.css";
import moment from "moment";
import "overlayscrollbars/overlayscrollbars.css";
import TaskCreationModal from "../../modals/TaskCreationModal/TaskCreationModal";
import ReassignModal from "../../modals/ReassignModal/ReassignModal";
import EllipseIcon from "../../assets/svgs/ellipse.svg";
import EllipseHoverIcon from "../../assets/svgs/ellipseHover.svg";
import EllipseFocusIcon from "../../assets/svgs/ellipseFocus.svg";
import ReassignIcon from "../../assets/svgs/reassign.svg";
import HoverReassignIcon from "../../assets/svgs/reassignHover.svg";
import WarningIcon from "../../assets/svgs/pendingWarning.svg";
import WarningGreenIcon from "../../assets/svgs/greenWarning.svg";
import NotesBlue from "../../assets/svgs/notesBlue.svg";
import NotesBlack from "../../assets/svgs/notesBlack.svg";
import DescriptionHighlight from "../../assets/svgs/descriptionHighlight.svg";
import DescriptionIcon from "../../assets/svgs/descriptionIcon.svg";
import NotesIcon from "../../assets/svgs/taskNotesIcon.svg";
import PeriodicIcon from "../../assets/svgs/periodicTaskIcon.svg";
import {
  changeTaskDone,
  removeTask,
  reassignTask,
} from "../../services/newdaily";

// function getNextBusinessDay(dateStr) {
//   const parsedDate = moment(dateStr, moment.ISO_8601, true);
//   if (!parsedDate.isValid()) {
//     console.warn("⚠️ Fecha no válida:", dateStr);
//     return moment().add(1, "day").format("YYYY-MM-DD");
//   }

//   const currentDay = parsedDate.day();

//   if (currentDay === 5) {
//     // Viernes → Lunes
//     parsedDate.add(3, "days");
//   } else if (currentDay === 6) {
//     // Sábado → Domingo
//     parsedDate.add(1, "day");
//   } else if (currentDay === 0) {
//     // Domingo → Lunes
//     parsedDate.add(1, "day");
//   } else {
//     // Otro día → Día siguiente normal
//     parsedDate.add(1, "day");
//   }

//   return parsedDate.format("YYYY-MM-DD");
// }

const TaskCard = ({
  task,
  user,
  updateTaskInState,
  onSuccess,
  admin = false,
  allUsers = [],
  allTasks = [],
  selectedDate,
  empleado,
  activeCounterType,
  isMobile,
  isModal,
  onToggleReassignModal,
  proyectosTodos,
  autoOpenReassignTaskId = null,
  onAutoOpenReassignConsumed,
}) => {
  const [checked, setChecked] = useState(task.Hecho === 1);
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showConfirmReassign, setShowConfirmReassign] = useState(false);
  const [deleteScope, setDeleteScope] = useState("single");
  const [menuPlacement, setMenuPlacement] = useState("bottom");

  const shouldHideActionButtons = checked;

  const [isHovered, setIsHovered] = useState(false);
  const [isOptionsHovered, setIsOptionsHovered] = useState(false);
  const [isReassignHovered, setIsReassignHovered] = useState(false);

  const optionsRef = useRef(null);
  const confirmModalRef = useRef(null);

  const isWarningActive = activeCounterType === "warning";
  const isNotesActive = activeCounterType === "notes";

  const shouldHighlightWarning = isWarningActive && task.IDOrigen < 0;
  const shouldHighlightNotes = isNotesActive && task.Notas?.trim() !== "";
  const shouldHighlight = shouldHighlightWarning || shouldHighlightNotes;
  const highlightColor = "#00ADC6";

  const optionsBtnRef = useRef(null);
  const [menuCoords, setMenuCoords] = useState({ top: 0, left: 0, width: 0 });

  const hasId = !!task?.id;
  

  const hasValidConfig = (cfg) => {
    if (cfg == null) return false;

    if (Array.isArray(cfg)) return cfg.length > 0;

    if (typeof cfg === "object") return Object.keys(cfg).length > 0;

    if (typeof cfg === "string") {
      const s = cfg.trim();
      if (!s) return false;
      try {
        let parsed = JSON.parse(s);
        if (typeof parsed === "string") parsed = JSON.parse(parsed);

        if (Array.isArray(parsed)) return parsed.length > 0;
        if (parsed && typeof parsed === "object") return Object.keys(parsed).length > 0;
        return false;
      } catch {
        return false;
      }
    }

    return false;
  };

  const isProjection = !!task?.is_projection;
  const parentPeriodicId = task?.parent_periodic_id;
  const isPeriodic = !!(task?.config_json && String(task.config_json).trim() !== "");
  const isPeriodicByConfig = hasValidConfig(task?.config_json);

  const hasParentPeriodic = parentPeriodicId !== null && parentPeriodicId !== undefined;

  const shouldShowPeriodicIcon =
    isPeriodicByConfig || hasParentPeriodic || isProjection;

  const shouldShowScopeSelector = (isProjection) || (!isProjection && isPeriodicByConfig);

  const closeOptionsMenu = () => {
    setOptionsVisible(false);
    setIsHovered(false);
  };

  const taskDate =
    task?.Fecha ||
    task?.date ||
    selectedDate ||
    moment().format("YYYY-MM-DD");

  const taskMoment = moment(taskDate, "YYYY-MM-DD");
  const isFutureDay = taskMoment.isAfter(moment(), "day");

  const shouldDisableCheckboxReveal =
    !admin && isFutureDay;

  const MENU_HEIGHT = 140;
  const MENU_OFFSET = 6;

  const openOptions = () => {
    if (!optionsBtnRef.current) return;

    const rect = optionsBtnRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    const shouldOpenUp = spaceBelow < MENU_HEIGHT && spaceAbove > MENU_HEIGHT;

    setMenuPlacement(shouldOpenUp ? "top" : "bottom");
    setMenuCoords({
      top: shouldOpenUp
        ? rect.top - MENU_OFFSET
        : rect.bottom + MENU_OFFSET,
      left: rect.right,
      width: rect.width,
    });

    setOptionsVisible(true);
  };

  useEffect(() => {
    setChecked(task.Hecho === 1);
  }, [task.Hecho]);

  useEffect(() => {
    if (checked) setOptionsVisible(false);
  }, [checked]);

  useEffect(() => {
    if (isMobile && isModal) {
      if (activeCounterType === "notes") {
        setShowNotes(true);
        setShowDescription(false);
      } else {
        setShowNotes(false);
      }
    }
  }, [activeCounterType, isMobile, isModal]);

  useEffect(() => {
    if (!optionsVisible) {
      setIsOptionsHovered(false);
    }
  }, [optionsVisible]);

  useEffect(() => {
    if (!admin) return;
    if (!task?.id) return;
    if (!autoOpenReassignTaskId) return;
    if (showReassignModal) return;
    if (String(task.id) !== String(autoOpenReassignTaskId)) return;

    console.log("[TaskCard] autoOpen detectado", {
      taskId: task.id,
      autoOpenReassignTaskId,
    });

    setShowReassignModal(true);
  }, [admin, task?.id, autoOpenReassignTaskId, showReassignModal]);

  useEffect(() => {
    if (!showReassignModal) return;
    if (!task?.id) return;
    if (!autoOpenReassignTaskId) return;
    if (String(task.id) !== String(autoOpenReassignTaskId)) return;

    console.log("[TaskCard] modal de reasignación abierto", {
      taskId: task.id,
    });

    onAutoOpenReassignConsumed?.(task.id);
  }, [showReassignModal, task?.id, autoOpenReassignTaskId, onAutoOpenReassignConsumed]);

  useEffect(() => {
    if (shouldDisableCheckboxReveal && isHovered) {
      setIsHovered(false);
    }
  }, [shouldDisableCheckboxReveal, isHovered]);

  const updateTaskStatus = async (taskId, newHecho) => {
    if (admin) return;
    
    try {
      const payload = {
        id: taskId,
        hecho: newHecho,
        ...(isProjection ? { task_date: taskDate } : {}),
      };
    
      const result = await changeTaskDone(payload);
    
      if (result?.OK === 1) {
        updateTaskInState(taskId, newHecho);
      } else {
        setChecked(!newHecho);
      }
    } catch (error) {
      console.error(`❌ Error al actualizar tarea ${taskId}:`, error);
      setChecked(!newHecho);
    }
  };

  const handleCheckboxClick = (e) => {
    if (admin) return;
    e.stopPropagation();
    const newChecked = !checked;
    setChecked(newChecked);
    updateTaskStatus(task.id, newChecked ? 1 : 0);
  };

  const toggleOptions = (e) => {
    e.stopPropagation();
    if (!optionsVisible) {
      document.dispatchEvent(new CustomEvent("closeAllOptions", { detail: task.id }));
      openOptions();
    } else {
      setOptionsVisible(false);
    }
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    setOptionsVisible(false);
    setIsEditModalOpen(true);
  };

  const handleReassignClick = async (e) => {
    e.stopPropagation();

    try {
      if (task.IDOrigen < 0) {
        const payload = {
          taskId: task.id,
          Empleado: task.Empleado,
        };

        if (isProjection) {
          payload.is_projection = true;
          payload.date = moment(taskDate).format("YYYY-MM-DD");
        }

        const result = await reassignTask(payload);

        if (result?.OK === 1) onSuccess("Se ha cancelado la reasignación correctamente");
        return;
      }

      const payload = { taskId: task.id };

      if (isProjection) {
        payload.is_projection = true;
        payload.date = moment(taskDate).format("YYYY-MM-DD");
      }
      const result = await reassignTask(payload);

      if (result?.OK === 1) onSuccess("Se ha solicitado la reasignación correctamente");
    } catch (error) {
      console.error("Error en reasignación:", error);
    } finally {
      setOptionsVisible(false);
    }
  };


  // const handleDuplicateForTomorrow = async (e) => {
  //   e.stopPropagation();

  //   const fechaBase = selectedDate || task.date || moment().format("YYYY-MM-DD");
  //   const fechaDuplicada = getNextBusinessDay(fechaBase);

  //   const finalTarea = task.Tarea === "Otra" ? "Otra" : Number(task.idTarea);
  //   const finalSubtarea =
  //     task.Tarea === "Otra"
  //       ? task.Subtarea
  //       : Number(task.idSubtarea);
  //   const finalProyecto = Number(task.idProyecto);
  //   const userId = Number(task.Empleado || localStorage.getItem("empleado"));

  //   const payload = {
  //     taskId: null,
  //     userId: userId,
  //     Tarea: finalTarea,
  //     Subtarea: finalSubtarea,
  //     Proyecto: finalProyecto,
  //     Fecha: fechaDuplicada,
  //     Minutos: task.Minutos || 0,
  //     Inicio: task.Inicio || "",
  //     Descripcion: task.Descripcion || "",
  //     Notas: task.Notas || "",
  //   };

  //   try {
  //     const result = await saveTask(payload);
  //     if (result?.OK === 1) {
  //       onSuccess("Tarea duplicada correctamente para el siguiente día hábil");
  //     } else {
  //       console.error("Error al duplicar la tarea:", result);
  //       onSuccess("Error al duplicar la tarea");
  //     }
  //   } catch (error) {
  //     console.error("Error en la duplicación:", error);
  //     onSuccess("Error al duplicar la tarea");
  //   }

  //   setOptionsVisible(false);
  // };

  const handleConfirmDelete = async (e) => {
    e.stopPropagation();

    let payload = null;

    if (!isProjection && !isPeriodicByConfig) {
      payload = { id: task.id };
    }

    else if (!isProjection && isPeriodicByConfig) {
      payload = {
        id: task.id,
        ...(deleteScope === "all" ? { remove_all: true } : {}),
      };
    }

    else if (isProjection) {
      payload = {
        periodic_task_id: parentPeriodicId,
        periodic_task_date: taskDate,
        ...(deleteScope === "all" ? { remove_all: true } : {}),
      };
    }

    else {
      console.warn("No se puede eliminar: caso no contemplado", { task });
      setShowConfirmDelete(false);
      setOptionsVisible(false);
      return;
    }
    console.log("🗑️ DELETE POST →", payload);

    try {
      const result = await removeTask(payload);

      if (result?.OK === 1) {
        onSuccess("Tarea eliminada correctamente");
      } else {
        console.error("Error al eliminar tarea:", result);
      }
    } catch (error) {
      console.error("Error en la petición de eliminación:", error);
    } finally {
      setShowConfirmDelete(false);
      setOptionsVisible(false);
    }
  };

  const handleCancelDelete = (e) => {
    e.stopPropagation();
    setShowConfirmDelete(false);
  };

  const handleConfirmReassign = async (e) => {
    e.stopPropagation();

    try {
      await handleReassignClick(e);
    } finally {
      setShowConfirmReassign(false);
    }
  };

  const handleCancelReassign = (e) => {
    e.stopPropagation();
    setShowConfirmReassign(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setOptionsVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Escucha el evento global para cerrar menús
  useEffect(() => {
    const handleCloseOptions = (event) => {
      if (event.detail !== task.id) {
        setOptionsVisible(false);
      }
    };
    document.addEventListener("closeAllOptions", handleCloseOptions);
    return () =>
      document.removeEventListener("closeAllOptions", handleCloseOptions);
  }, [task.id]);

  useEffect(() => {
    if (!showConfirmDelete) return;
    const handleClickOutsideModal = (event) => {
      if (confirmModalRef.current && !confirmModalRef.current.contains(event.target)) {
        setShowConfirmDelete(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideModal);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    };
  }, [showConfirmDelete]);

  useEffect(() => {
    if (showReassignModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showReassignModal]);

  useEffect(() => {
    if (!optionsVisible) return;
    const close = () => setOptionsVisible(false);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => {
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [optionsVisible]);

  useEffect(() => {
    if (onToggleReassignModal) {
      onToggleReassignModal(showReassignModal);
    }
  }, [showReassignModal]);

  const durationMinutes = task.Minutos ?? 0;
  const durationHours = Math.floor(durationMinutes / 60);
  const durationText = durationHours
    ? `${durationHours}h ${durationMinutes % 60 ? `${durationMinutes % 60}min` : ""}`
    : `${durationMinutes} min`;

  const startTime = task.Inicio ? moment(task.Inicio, "HH:mm:ss") : null;
  const endTime = startTime ? moment(startTime).add(durationMinutes, "minutes") : null;
  const timeRange = startTime ? `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")}` : "";

  const shouldApplyHover =
    !isMobile &&
    !shouldDisableCheckboxReveal &&
    (isHovered || optionsVisible);

  const baseClass = isMobile ? styles.taskcardMobile : styles.taskCard;

  const containerClassName = admin
    ? `${baseClass} ${styles.adminTaskCard} ${checked ? styles.checked : ""} ${shouldApplyHover ? styles.hovered : ""}`
    : `${baseClass} ${checked ? styles.checked : ""} ${shouldApplyHover ? styles.hovered : ""}`;

  const reassignButtonText =
    Number(task.IDOrigen) < 0
      ? "Cancelar reasignación"
      : "Solicitar reasignación";

  const optionsIconSrc = optionsVisible
    ? EllipseFocusIcon
    : isOptionsHovered
      ? EllipseHoverIcon
      : EllipseIcon;

  const reassignIconSrc = isReassignHovered ? HoverReassignIcon : ReassignIcon;

  const handleReassignIconClick = (e) => {
    e.stopPropagation();

    setIsHovered(false);
    setIsOptionsHovered(false);
    setIsReassignHovered(false);
    setOptionsVisible(false);

    e.currentTarget.blur();
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    setShowReassignModal(true);
  };

  const handleMouseEnter = () => {
    if (shouldDisableCheckboxReveal) return;
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (!optionsVisible) {
      setIsHovered(false);
    }
  };

  return (
    <>
      <div
        data-testid="task-card"
        data-task-id={task.id}
        data-task-title={`${task.Tarea} ${task.Subtarea} ${task.Proyecto}`}
        className={`${containerClassName} ${isMobile && isModal ? styles.taskCardModalMobile : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className={
            admin
              ? styles.adminLeftBar
              : `${styles.leftBar} ${isMobile ? styles.leftBarMobile : ""}`
          }
          style={{ backgroundColor: task.color || "#ccc" }}
        >
          {!admin && !shouldDisableCheckboxReveal && (
            <label
              className={`${styles.checkboxLabel} ${isMobile ? styles.checkboxVisibleMobile : ""}`}
            >
              <input
                type="checkbox"
                className={styles.hiddenCheckbox}
                checked={checked}
                onChange={handleCheckboxClick}
              />
              <span className={styles.customCheckbox}></span>
            </label>
          )}
        </div>

        <div
          className={`${styles.taskDetails} ${isMobile && isModal
            ? styles.taskDetailsModalMobile
            : isMobile
              ? styles.taskDetailsMobile
              : ""
            }`}
        >
          {(task.IDOrigen < 0 || (task.Origen && task.IDOrigen !== task.Empleado)) && (
            <div className={styles.originBanner}>
              {task.Origen && task.IDOrigen !== task.Empleado && task.IDOrigen !== -task.Empleado && (
                <div className={styles.originBadge}>
                  <img
                    src={WarningGreenIcon}
                    alt="Advertencia"
                    className={styles.originIcon}
                  />
                  <span className={styles.originText}>
                    Tarea de {task.Origen} asignada
                  </span>
                </div>
              )}

              {task.IDOrigen < 0 && (
                <div data-testid="pending-reassign-badge" className={styles.pendingBadge}>
                  <img
                    src={WarningIcon}
                    alt="Warning"
                    className={styles.pendingIcon}
                  />
                  <span className={styles.pendingText}>
                    Solicitud pendiente
                  </span>
                </div>
              )}
            </div>
          )}
          <p
            className={styles.taskTitle}
            style={{
              textDecoration: checked ? "line-through" : "none",
              textDecorationColor: shouldHighlight && checked ? highlightColor : undefined,
              color: shouldHighlight ? highlightColor : undefined,
            }}
          >
            <span
              className={styles.task}
              style={shouldHighlight ? { color: highlightColor } : undefined}
            >
              {task.Tarea}
            </span>{" "}
            <span
              className={styles.subtask}
              style={shouldHighlight ? { color: highlightColor } : undefined}
            >
              {task.Subtarea}
            </span>{" "}
            <span
              style={{
                fontSize: "18px",
                ...(shouldHighlight ? { color: highlightColor } : {}),
              }}
            >
              para
            </span>{" "}
            <span
              className={styles.project}
              style={shouldHighlight ? { color: highlightColor } : undefined}
            >
              {task.Proyecto}
            </span>
          </p>
          <p className={styles.taskTime}>
            {durationText} {startTime && `| ${timeRange}`}
          </p>

          {!isMobile && task.Descripcion?.trim() && (
            <p className={styles.taskDescription}>
              {task.Descripcion}
            </p>
          )}

          {!isMobile && task.Notas?.trim() && (
            <p className={styles.taskNote}>
              <img src={NotesIcon} alt="" aria-hidden="true" className={styles.noteInlineIcon} />
              <span>{task.Notas}</span>
            </p>
          )}

          {isMobile && showDescription && task.Descripcion?.trim() && (
            <p className={styles.taskDescriptionMobile}>
              {task.Descripcion}
            </p>
          )}

          {isMobile && showNotes && task.Notas?.trim() && (
            <p className={styles.taskNoteMobile}>
              <img src={NotesIcon} alt="" aria-hidden="true" className={styles.noteInlineIcon} />
              <span>{task.Notas}</span>
            </p>
          )}

          {isMobile && (task.Descripcion?.trim() || task.Notas?.trim()) && (
            <div className={styles.mobileActions}>
              {task.Descripcion?.trim() && (
                <button
                  type="button"
                  className={styles.iconButton}
                  onClick={() => {
                    setShowDescription(prev => {
                      const newValue = !prev;
                      if (newValue) setShowNotes(false);
                      return newValue;
                    });
                  }}
                >
                  <img
                    src={showDescription ? DescriptionHighlight : DescriptionIcon}
                    alt="Descripción"
                  />
                  <span
                    className={`${styles.iconText} ${showDescription ? styles.highlightText : ""
                      }`}
                  >
                    Descripción
                  </span>
                </button>
              )}

              {task.Notas?.trim() && (
                <button
                  type="button"
                  className={styles.iconButton}
                  onClick={() => {
                    setShowNotes(prev => {
                      const newValue = !prev;
                      if (newValue) setShowDescription(false);
                      return newValue;
                    });
                  }}
                >
                  <img
                    src={showNotes ? NotesBlue : NotesBlack}
                    alt="Notas"
                  />
                  <span
                    className={`${styles.iconText} ${showNotes ? styles.highlightText : ""
                      }`}
                  >
                    Notas
                  </span>
                </button>
              )}
            </div>
          )}


        </div>

        <div
          className={`${styles.topRightActions} ${admin ? styles.topRightActionsAdmin : ""}`}
          ref={!admin ? optionsRef : null}
        >
          {shouldShowPeriodicIcon && (
            <div className={styles.periodicBadge}>
              <img
                src={PeriodicIcon}
                alt="Tarea periódica"
                className={styles.periodicIcon}
              />
            </div>
          )}
        
          {!shouldHideActionButtons && (
            <>
              {admin ? (
                <button
                  data-testid="admin-task-reassign-button"
                  className={styles.optionsReassignButtonTop}
                  onClick={handleReassignIconClick}
                  onMouseEnter={() => setIsReassignHovered(true)}
                  onMouseLeave={() => setIsReassignHovered(false)}
                  aria-label="Reasignar tarea"
                >
                  <img
                    src={reassignIconSrc}
                    alt="Reasignar"
                    className={`${styles.reassignIconTop} ${isReassignHovered ? styles.reassignIconTopHover : ""}`}
                  />
                </button>
              ) : (
                <button
                  ref={optionsBtnRef}
                  data-testid="task-options-button"
                  className={styles.optionsButtonTop}
                  onClick={toggleOptions}
                  onMouseEnter={() => setIsOptionsHovered(true)}
                  onMouseLeave={() => setIsOptionsHovered(false)}
                  aria-haspopup="menu"
                  aria-expanded={optionsVisible}
                >
                  <img
                    src={optionsIconSrc}
                    alt="Opciones"
                    className={styles.optionsIconVertical}
                  />
                </button>
              )}
            </>
          )}
        </div>
        
        {!admin && !shouldHideActionButtons && optionsVisible &&
          createPortal(
            <div
              className={`${styles.portalMenu} ${
                menuPlacement === "top"
                  ? styles.portalMenuTop
                  : styles.portalMenuBottom
              }`}
              style={{ top: menuCoords.top, left: menuCoords.left }}
              role="menu"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                data-testid="task-edit-menu-button"
                className={styles.optionItem}
                onClick={(e) => {
                  closeOptionsMenu();
                  handleEditClick(e);
                }}
              >
                Editar
              </button>
              
              <button
                data-testid="task-reassign-menu-button"
                className={styles.optionItem}
                onClick={async (e) => {
                  e.stopPropagation();
                  closeOptionsMenu();
                
                  if (Number(task.IDOrigen) < 0) {
                    await handleReassignClick(e);
                    return;
                  }
                
                  setShowConfirmReassign(true);
                }}
              >
                {reassignButtonText}
              </button>
              
              <button
                data-testid="task-delete-menu-button"
                className={styles.optionItem}
                onClick={(e) => {
                  closeOptionsMenu();
                  setDeleteScope("single");
                  setShowConfirmDelete(true);
                }}
              >
                Eliminar
              </button>
            </div>,
            document.body
          )}
      </div>

      {showConfirmDelete && createPortal(
        <div className={styles.confirmModal} onClick={() => setShowConfirmDelete(false)}>
          <div
            data-testid="delete-confirm-modal"
            className={styles.confirmContent}
            onClick={(e) => e.stopPropagation()}
            ref={confirmModalRef}
          >
            <p className={styles.confirmTitle}>
              Eliminar esta tarea de forma permanente
            </p>

            {/* TEXTO: solo cuando is_projection=false y parent_periodic_id=null */}
            {!isProjection && !hasParentPeriodic && (
              <p className={styles.confirmText}>
                Se eliminará definitivamente y no podrás recuperarla más adelante.
              </p>
            )}

            {/* SELECTOR: cuando (is_projection=false y tiene parent) o is_projection=true */}
            {shouldShowScopeSelector && (
              <div className={styles.deleteScopeBox}>
                <label className={styles.deleteScopeOption}>
                  <input
                    data-testid="delete-scope-single"
                    type="radio"
                    name={`deleteScope-${task.id || taskDate}`}
                    value="single"
                    checked={deleteScope === "single"}
                    onChange={() => setDeleteScope("single")}
                  />
                  <span className={styles.radioDot} />
                  <span className={styles.deleteScopeText}>Esta tarea</span>
                </label>

                <label className={styles.deleteScopeOption}>
                  <input
                    data-testid="delete-scope-all"
                    type="radio"
                    name={`deleteScope-${task.id || taskDate}`}
                    value="all"
                    checked={deleteScope === "all"}
                    onChange={() => setDeleteScope("all")}
                  />
                  <span className={styles.radioDot} />
                  <span className={styles.deleteScopeText}>Esta tarea y las posteriores</span>
                </label>
              </div>
            )}

            <div className={styles.confirmButtons}>
              <button className={styles.cancelButton} onClick={handleCancelDelete}>
                Cancelar
              </button>

              <button
                data-testid="confirm-delete-button"
                className={styles.deleteButton}
                onClick={handleConfirmDelete}
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {showConfirmReassign && createPortal(
        <div
          className={styles.confirmModal}
          onClick={() => setShowConfirmReassign(false)}
        >
          <div
            data-testid="reassign-confirm-modal"
            className={styles.confirmContent}
            onClick={(e) => e.stopPropagation()}
          >
            <p className={styles.confirmTitle}>
              Solicitar reasignación
            </p>

            <p className={styles.confirmText}>
              Se enviará una notificación a operaciones.
            </p>

            <div className={styles.confirmButtons}>
              <button
                className={styles.cancelButton}
                onClick={handleCancelReassign}
              >
                Cancelar
              </button>

              <button
                data-testid="confirm-reassign-send-button"
                className={styles.deleteButton}
                onClick={handleConfirmReassign}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Modal deL formulario */}

      {isEditModalOpen && (
        <TaskCreationModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          taskData={task}
          onSuccess={onSuccess}
          empleado={empleado}
          isMobile={isMobile}
          proyectosTodos={proyectosTodos}
        />
      )}

      {/* Modal de reasignacion */}

      <ReassignModal
        isOpen={showReassignModal}
        onClose={() => setShowReassignModal(false)}
        task={task}
        allUsers={allUsers}
        allTasks={allTasks}
        selectedDate={selectedDate}
        isMobile={isMobile}
        onSuccess={onSuccess}
        empleado={empleado}
      />
    </>
  );
};

export default TaskCard;
